export enum SeatStatuses {
  BLOCKED = 30786,
  FREE = 30785
}
